module.exports = __webpack_public_path__ + "braveuistatic/img/apps/www.bravenet.com/src/assets/img/contactforms/bravenet_contact_forms_download_all_data.png";